import axios from "axios";
import router from "@/router";

let isRedirecting = false; // Flag to prevent multiple redirects

let headers = {};
let headersWithImages = { "Content-Type": "multipart/form-data" };

async function makeApiCall(
  url, // FIRST PARAM  FOR END POINT
  method = "GET", // SECOND PARAM FOR METHOD TYPE BY DEFAULT GET
  data, //THIRD PARAM FOR DATA/BODY
  noAuth, //4TH IF WE HAVE TO DEAL WITH AUTH
  sendConfig,
  ...config
) {
  try {
    const roomround_access_token = localStorage.getItem(
      "roomround_access_token"
    );

    if (roomround_access_token !== null) {
      headers.Authorization = `Bearer ${roomround_access_token}`;
    }

    const response = await axios({
      method,
      data,
      headers,
      url: `${process.env.VUE_APP_API_URL}${url}`,
      ...config,
    });

    if (sendConfig) {
      return response;
    }

    return response;
  } catch (error) {
    if (error?.response && error?.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    }
  }
}
async function makeApiCallWithImages(
  url, // FIRST PARAM FOR ENDPOINT
  method = "GET", // SECOND PARAM FOR METHOD TYPE BY DEFAULT GET
  data, // THIRD PARAM FOR DATA/BODY
  noAuth, // 4TH PARAM IF WE HAVE TO DEAL WITH AUTH
  sendConfig,
  ...config
) {
  const roomround_access_token = localStorage.getItem("roomround_access_token");

  if (roomround_access_token !== null) {
    headersWithImages.Authorization = `Bearer ${roomround_access_token}`;
  }

  try {
    const response = await axios({
      method,
      data,
      headers: headersWithImages,
      url: `${process.env.VUE_APP_API_URL}${url}`,
      ...config,
    });

    if (sendConfig) {
      return response;
    }

    return response;
  } catch (error) {
    if (error.response && error.response.status === 401 && !isRedirecting) {
      isRedirecting = true;

      // Clear session and local storage
      sessionStorage.clear();
      localStorage.clear();

      // Show SweetAlert for Unauthorized access
      this.$swal({
        title: "Session Expired",
        text: "Your session has expired. Please log in again.",
        icon: "warning",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        // Redirect to login
        router.push("/login").finally(() => {
          isRedirecting = false;
        });
      });
    } else {
      console.error("API error:", error);
      return Promise.reject(error);
    }
  }
}

export { makeApiCall, makeApiCallWithImages };
